import React, { useMemo, useState } from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent } from '../components/Card';
import { FileText, Download } from 'lucide-react';
import { Button } from '../components/Button';
import { toast } from 'sonner';
const reports = [{
  name: 'Presidential Daily Brief',
  desc: 'Ringkasan harian intelijen siber untuk Presiden.',
  cadence: 'Harian',
  restr: 'RAHASIA'
}, {
  name: 'Weekly National Sentiment Report',
  desc: 'Sentimen lintas isu & wilayah mingguan.',
  cadence: 'Mingguan',
  restr: 'TERBATAS'
}, {
  name: 'Regional Visit Brief',
  desc: 'Intelijen kunjungan Presiden per provinsi.',
  cadence: 'On-Demand',
  restr: 'RAHASIA'
}, {
  name: 'Crisis Alert Report',
  desc: 'Laporan instan saat krisis terdeteksi.',
  cadence: 'Real-time',
  restr: 'KRITIS'
}, {
  name: 'Actor Network Report',
  desc: 'Pemetaan aktor & klaster narasi.',
  cadence: 'On-Demand',
  restr: 'RAHASIA'
}, {
  name: 'Bot & Buzzer Detection Report',
  desc: 'Kampanye terkoordinasi & bot terdeteksi.',
  cadence: 'Harian',
  restr: 'TERBATAS'
}, {
  name: 'Ministry Response Report',
  desc: 'Performa respons K/L terhadap tasking.',
  cadence: 'Mingguan',
  restr: 'INTERNAL'
}, {
  name: 'Program Impact Report',
  desc: 'Dampak program presiden ke publik.',
  cadence: 'Bulanan',
  restr: 'TERBATAS'
}, {
  name: 'Deepfake Verification Report',
  desc: 'Hasil verifikasi media sintetis.',
  cadence: 'On-Demand',
  restr: 'RAHASIA'
}, {
  name: 'Legal Evidence Package',
  desc: 'Paket bukti dengan chain-of-custody.',
  cadence: 'On-Demand',
  restr: 'PROYUSTITIA'
}, {
  name: 'Foreign Influence Report',
  desc: 'Pengaruh asing terhadap narasi nasional.',
  cadence: 'Bulanan',
  restr: 'RAHASIA'
}, {
  name: 'National Stability Report',
  desc: 'Indeks stabilitas nasional digital.',
  cadence: 'Mingguan',
  restr: 'RAHASIA'
}, {
  name: 'IPOLEKSOSBUDHANKAM Assessment',
  desc: 'Analisis 7 gatra stabilitas digital.',
  cadence: 'Mingguan',
  restr: 'RAHASIA'
}, {
  name: 'Astagatra Strategic Assessment',
  desc: 'Trigatra + Pancagatra digital.',
  cadence: 'Bulanan',
  restr: 'RAHASIA'
}];
const restrColor: Record<string, string> = {
  KRITIS: 'bg-red-500/10 text-red-500 border-red-500/20',
  RAHASIA: 'bg-amber-500/10 text-amber-500 border-amber-500/20',
  TERBATAS: 'bg-blue-500/10 text-blue-500 border-blue-500/20',
  INTERNAL: 'bg-muted text-muted-foreground border-border/50',
  PROYUSTITIA: 'bg-purple-500/10 text-purple-500 border-purple-500/20'
};
export function Reports() {
  const [cadenceFilter, setCadenceFilter] = useState<string>('SEMUA');
  const [restrFilter, setRestrFilter] = useState<string>('SEMUA');
  const cadences = ['SEMUA', 'Harian', 'Mingguan', 'Bulanan', 'Real-time', 'On-Demand'];
  const restrs = ['SEMUA', 'KRITIS', 'RAHASIA', 'TERBATAS', 'INTERNAL', 'PROYUSTITIA'];
  const filtered = useMemo(() => {
    return reports.filter(r => {
      if (cadenceFilter !== 'SEMUA' && r.cadence !== cadenceFilter) return false;
      if (restrFilter !== 'SEMUA' && r.restr !== restrFilter) return false;
      return true;
    });
  }, [cadenceFilter, restrFilter]);
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-3074">
      <PageHeader group="Workspace" title="Laporan & Output Sistem" description="Semua jenis laporan yang dihasilkan GARUDA SHIELD C4I, dengan klasifikasi & cadence." icon={FileText} data-id="element-3075" />

      {/* Filter chips */}
      <div className="flex flex-col gap-3" data-id="element-3076">
        <div className="flex flex-wrap items-center gap-2" data-id="element-3077">
          <span className="font-mono text-[10px] uppercase text-muted-foreground mr-1" data-id="element-3078">
            Cadence:
          </span>
          {cadences.map(c => <button key={c} onClick={() => setCadenceFilter(c)} className={`font-mono text-[10px] px-2 py-1 rounded border transition-colors ${cadenceFilter === c ? 'bg-primary/10 border-primary/40 text-primary' : 'bg-muted/20 border-border/50 text-muted-foreground hover:bg-muted/30'}`} data-id="element-3079">
              {c}
            </button>)}
        </div>
        <div className="flex flex-wrap items-center gap-2" data-id="element-3080">
          <span className="font-mono text-[10px] uppercase text-muted-foreground mr-1" data-id="element-3081">
            Klasifikasi:
          </span>
          {restrs.map(r => <button key={r} onClick={() => setRestrFilter(r)} className={`font-mono text-[10px] px-2 py-1 rounded border transition-colors ${restrFilter === r ? 'bg-primary/10 border-primary/40 text-primary' : 'bg-muted/20 border-border/50 text-muted-foreground hover:bg-muted/30'}`} data-id="element-3082">
              {r}
            </button>)}
        </div>
      </div>

      {filtered.length === 0 ? <div className="rounded-lg border border-dashed border-border/50 bg-muted/10 p-12 text-center" data-id="element-3083">
          <FileText className="size-10 mx-auto text-muted-foreground opacity-40 mb-2" data-id="element-3084" />
          <p className="text-sm text-muted-foreground font-mono" data-id="element-3085">
            Tidak ada laporan yang cocok dengan filter saat ini.
          </p>
        </div> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-3086">
          {filtered.map(r => <Card key={r.name} className="bg-card/50 border-border/50 hover:bg-card/70 transition" data-id="element-3087">
              <CardContent className="p-4 flex flex-col h-full" data-id="element-3088">
                <div className="flex items-start justify-between gap-2 mb-2" data-id="element-3089">
                  <FileText className="size-5 text-primary shrink-0" data-id="element-3090" />
                  <span className={`font-mono text-[9px] px-1.5 py-0.5 rounded border ${restrColor[r.restr]}`} data-id="element-3091">
                    {r.restr}
                  </span>
                </div>
                <h3 className="font-bold text-sm mb-1" data-id="element-3092">{r.name}</h3>
                <p className="text-[11px] text-muted-foreground leading-relaxed flex-1" data-id="element-3093">
                  {r.desc}
                </p>
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-border/50" data-id="element-3094">
                  <span className="font-mono text-[9px] text-muted-foreground" data-id="element-3095">
                    CADENCE: {r.cadence}
                  </span>
                  <Button size="xs" variant="outline" className="h-6 text-[9px] font-mono" onClick={() => toast.success(`${r.name} sedang disiapkan...`, {
              description: 'PDF akan tersedia dalam 30 detik.'
            })} data-id="element-3096">
                    <Download className="size-3 mr-1" data-id="element-3097" />
                    Generate
                  </Button>
                </div>
              </CardContent>
            </Card>)}
        </div>}
    </div>;
}